import { takoUUID } from '../utils/takoUUID';
import {
    setHxAttrs,
    createHxTarget,
    createHxIndicator,
} from '../utils/htmxHelper';

/**
 * Creates an htmx-powered popover.
 * @param popoverButton The button that triggers the popover.
 */
export const createHtmxPopover = (popoverButton: HTMLElement): void => {
    const dataPopoverTarget =
        popoverButton.getAttribute('data-popover-target') ||
        takoUUID('popover');

    popoverButton.setAttribute('data-popover-target', dataPopoverTarget);

    const popoverId = dataPopoverTarget.replace('#', '');
    const hxPopover = document.querySelector(`#${popoverId}`);

    // Add hx attributes to trigger element
    setHxAttrs(popoverButton, 'popover');

    const popoverDiv = (hxPopover ||
        document.createElement('div')) as HTMLElement;

    if (!hxPopover) {
        popoverDiv.setAttribute('id', popoverId);
    }

    // Create popover with header (if title is provided) and body with hx target id, hx container, hx indicator
    popoverDiv.classList.add('tako-popover');
    popoverDiv.setAttribute('id', popoverId);
    setPopoverAttrs(popoverButton, popoverDiv);
    setPopoverModifierClass(popoverButton, popoverDiv);

    const popoverHTMXWrapper = document.createElement('div');
    popoverHTMXWrapper.classList.add('tako-popover__body');
    const popoverHTMXContent = createHxTarget(popoverButton);

    const hxIndicator = createHxIndicator(popoverButton, 'sm');
    popoverHTMXWrapper.prepend(hxIndicator);
    popoverHTMXWrapper.appendChild(popoverHTMXContent);
    popoverDiv.appendChild(popoverHTMXWrapper);

    if (!hxPopover) {
        popoverButton.insertAdjacentElement('afterend', popoverDiv);
    }
};

/**
 * Sets attributes on the popover element.
 * @param popoverButton The button that triggers the popover.
 * @param popover The popover element.
 */
const setPopoverAttrs = (
    popoverButton: HTMLElement,
    popover: HTMLElement,
): void => {
    const dataFixed = popoverButton.getAttribute('data-popover-fixed');
    const dataPlacement = popoverButton.getAttribute('data-popover-placement');

    // Add data attributes to popover if provided with trigger element
    if (dataFixed) {
        const isPopoverFixed = dataFixed === 'true' || dataFixed === '';
        if (isPopoverFixed) {
            popover.setAttribute('data-fixed', 'true');
        }
    }

    if (dataPlacement) {
        popover.setAttribute('data-placement', dataPlacement);
    }
};

/**
 * Adds modifier classes to the popover element.
 * @param popoverButton The button that triggers the popover.
 * @param popover The popover element.
 */
const setPopoverModifierClass = (
    popoverButton: HTMLElement,
    popover: HTMLElement,
): void => {
    const dataWidth = popoverButton.getAttribute('data-popover-width');

    // Add modifier class to popover if provided with trigger element
    if (dataWidth) {
        popover.classList.add(`tako-popover--${dataWidth}`);
    }
};
